import React, { useState } from 'react';
import { X, Send, MessageSquare, Loader2 } from 'lucide-react';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
// התיקון כאן: הוספנו נקודה נוספת (../) כדי לצאת מתיקיית הרכיבים ולמצוא את הקובץ
import { db, auth } from '../firebase';

const SupportForm = ({ onClose }) => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!subject.trim() || !message.trim()) {
      alert('נא למלא נושא ותוכן הודעה');
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "contact_requests"), {
        subject,
        message,
        userEmail: auth.currentUser?.email || "לא הוזן",
        userName: auth.currentUser?.displayName || "משתמש",
        userPhone: auth.currentUser?.phoneNumber || "", 
        userId: auth.currentUser?.uid,
        createdAt: serverTimestamp(),
        status: 'unread',
        type: 'general'
      });

      alert('ההודעה נשלחה בהצלחה! נחזור אליך בהקדם.');
      setSubject('');
      setMessage('');
      onClose();
    } catch (error) {
      console.error("Error sending support ticket:", error);
      alert('אירעה שגיאה בשליחת ההודעה. אנא נסה שוב.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl overflow-hidden animate-in fade-in zoom-in duration-200">
        
        <div className="bg-blue-600 p-4 text-white flex justify-between items-center">
          <div className="flex items-center gap-2">
            <MessageSquare size={20} />
            <h2 className="font-bold text-lg">צור קשר / תמיכה</h2>
          </div>
          <button 
            onClick={onClose}
            className="p-1 hover:bg-blue-500 rounded-full transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              נושא הפנייה
            </label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
              placeholder="באיזה נושא מדובר?"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              תוכן ההודעה
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows="4"
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none"
              placeholder="פרט כאן את בקשתך..."
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2.5 rounded-lg font-medium hover:bg-blue-700 active:scale-95 transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>
                <Loader2 size={18} className="animate-spin" />
                שולח...
              </>
            ) : (
              <>
                <Send size={18} />
                שלח הודעה
              </>
            )}
          </button>

          <p className="text-xs text-gray-500 text-center mt-2">
            צוות התמיכה שלנו משתדל לענות תוך 24 שעות
          </p>
        </form>
      </div>
    </div>
  );
};

export default SupportForm;